// Not ported (dead in the Angular app): getStatements
import { api } from '@/core/http/apiClient';
import type {
  CalculateProfitAllocationPayload,
  PartnerMemberBalanceScreen,
  PartnerMemberRow,
  PartnerMemberScreen,
  ProfitAllocationScreen,
  SavePartnerMemberBalancesPayload,
  SavePartnerMemberPayload,
  SaveProfitAllocationPayload,
} from '@/core/models/partner-allocation.models';

const base = 'ProfitAllocation/';

export const partnerAllocationService = {
  // ---- Partners and members ----

  getPartners: (clientId: string) => api.get<PartnerMemberScreen>(`${base}getPartners/${clientId}`),

  savePartner: (payload: SavePartnerMemberPayload) => api.post<PartnerMemberRow>(`${base}savePartner`, payload),

  deletePartner: (id: string) => api.post<boolean>(`${base}deletePartner/${id}`, {}),

  // ---- Profit allocation ----

  /** Without a period id the API uses the client's latest accounting period. */
  getAllocation: (clientId: string, accountingPeriodId?: string | null) =>
    api.get<ProfitAllocationScreen>(
      `${base}getAllocation/${clientId}`,
      accountingPeriodId ? { params: { accountingPeriodId } } : {},
    ),

  saveAllocation: (payload: SaveProfitAllocationPayload) =>
    api.post<ProfitAllocationScreen>(`${base}saveAllocation`, payload),

  calculateAllocation: (payload: CalculateProfitAllocationPayload) =>
    api.post<ProfitAllocationScreen>(`${base}calculateAllocation`, payload),

  // ---- Capital, current and loan accounts ----

  getBalances: (clientId: string, accountingPeriodId?: string | null) =>
    api.get<PartnerMemberBalanceScreen>(
      `${base}getBalances/${clientId}`,
      accountingPeriodId ? { params: { accountingPeriodId } } : {},
    ),

  saveBalances: (payload: SavePartnerMemberBalancesPayload) =>
    api.post<PartnerMemberBalanceScreen>(`${base}saveBalances`, payload),
};
